import { WindowSizesEnum } from "~/enums";
import { onMounted, onUnmounted, ref } from "vue";

export function useGetWindowSize() {
  const windowSize = ref(getWindowSize());

  function getWindowSize() {
    if (typeof window === "undefined") return WindowSizesEnum.DESKTOP;
    const w = window.innerWidth;
    if (w >= 1920) {
      return WindowSizesEnum.DESKTOP;
    } else if (w >= 1441 && w < 1920) {
      return WindowSizesEnum.LAPTOP;
    } else if (w >= 1280 && w < 1441) {
      return WindowSizesEnum.LAPTOP_SM;
    } else if (w >= 1024 && w < 1280) {
      return WindowSizesEnum.TABLET_LANDSCAPE;
    } else if (w >= 768 && w < 1024) {
      return WindowSizesEnum.TABLET_PORTRAIT;
    } else {
      return WindowSizesEnum.MOBILE;
    }
  }

  function updateWindowSize() {
    windowSize.value = getWindowSize();
  }

  onMounted(() => {
    window.addEventListener("resize", updateWindowSize);
    updateWindowSize();
  });
  onUnmounted(() => window.removeEventListener("resize", updateWindowSize));

  return windowSize;
}
